module.exports = __webpack_public_path__ + "static/media/photo2.4439e3b4.jpg";